import {resolveBackground} from '#core/utils/color-utils.js';
import {icon} from '#core/utils/style-utils.js';

import {generateBorder} from '#core/application/modules/tiles/border/index.js';
import {generateViewSwitcher} from '#core/application/modules/tiles/view-switcher/index.js';
import {generateMarketsGroupsSelector} from '#core/application/modules/tiles/markets-groups-selector/index.js';

export function tableLeaguePageFactory(PALETTE) {
    const TABLE_LEAGUE_PHASE_SWITCHER = generateViewSwitcher(PALETTE.TABLE_LEAGUE_PHASE_SWITCHER);

    return {
        TableView: {
            container: {
                style: {
                    ...resolveBackground(PALETTE.TABLE_LEAGUE_CONTAINER_BG),
                    ...generateBorder(PALETTE.TABLE_LEAGUE_CONTAINER_BORDER),
                },
            },
            titleImg: icon(PALETTE.TABLE_LEAGUE_TITLE_ICON_COLOR),
            titleText: {
                style: {
                    ...PALETTE.TABLE_LEAGUE_TITLE_TEXT,
                },
            },
            viewToggle: {
                container: TABLE_LEAGUE_PHASE_SWITCHER.switcherContainer,
                selectableButton: TABLE_LEAGUE_PHASE_SWITCHER.switcherButton,
            },
            // table
            marketGroupSelector: generateMarketsGroupsSelector(PALETTE.TABLE_MARKETS_GROUPS_SELECTOR),
            statsToggleIcon: icon(PALETTE.TABLE_STATS_BUTTON_ICON_COLOR, 'all-stats'),
            statsToggleText: {
                style: {
                    ...PALETTE.TABLE_STATS_BUTTON_TEXT,
                },
            },
        },
    };
}
